import type { ReactNode } from 'react'

import { ICONS } from '@/components/icons/icons'

import styles from './Notice.module.css'

export function Notice({ tone = 'info', children }: { tone?: 'info' | 'warn'; children: ReactNode }) {
  const Icon = tone === 'warn' ? ICONS.warning : ICONS.info
  return (
    <div className={`${styles.notice} ${styles[tone]}`} role="note">
      <Icon className={styles.icon} size={15} />
      <div>{children}</div>
    </div>
  )
}
